import { MoovVariableDTO } from "../DTO/moovVariableDTO";
import { BasicRequest } from "./basicRequest";

export class CreateMoovVariableRequest extends BasicRequest {
    
    public moovVariable!:MoovVariableDTO;

    constructor(){
        super();
    }
}